var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wrapper-page',{ref:"wrapper"},[_c('div',{},[_vm._v("UNDER CONSTRUCTION")])])
}
var staticRenderFns = []

export { render, staticRenderFns }